module.exports = __webpack_public_path__ + "img/step22_a_remove stacker supports.b81e9474.png";